import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=99ff43fa"
import script from "./SerialNumber.vue?vue&type=script&lang=js"
export * from "./SerialNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports